import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import S from './CookieConsent.styles'
import useCookieConsent from './useCookieConsent'
import { STORAGE_KEY } from './constants'

const CookieConsent: React.FC = () => {
  const ctx = useCookieConsent()

  useEffect(() => {
    // Check if user has already given consent
    const storedConsent = localStorage.getItem(STORAGE_KEY)
    if (storedConsent) {
      ctx.updateConsent(JSON.parse(storedConsent))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const acceptAllCookies = () => {
    const opts = {
      essential: true,
      performance: true,
      functional: true,
      targetting: true,
    }

    ctx.updateConsent(opts)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(opts))

    ctx.closeConsent()
  }

  const openPreferences = () => {
    ctx.openPreferences()
  }

  return (
    <S.Backdrop>
      <S.Dialog initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
        <S.Content>
          <FormattedMessage id="static.page.cookie_consent.statement" tagName="p" />
          <S.Actions>
            <button type="button" aria-label="cookie_accept_all" onClick={acceptAllCookies}>
              <FormattedMessage id="static.page.cookie_consent.accept_all_button" />
            </button>
            <button type="button" aria-label="cookie_settings" className="reverse" onClick={openPreferences}>
              <FormattedMessage id="static.page.cookie_consent.settings_button" />
            </button>
          </S.Actions>
        </S.Content>
      </S.Dialog>
    </S.Backdrop>
  )
}

export default CookieConsent
